

define([], function () {
    return {
        'AC': {
            'status': 'reserved',
            'phoneCountryCode': '247',
            'showCountryCodeList': false
        },
        'AD': {
            'status': 'assigned',
            'phoneCountryCode': '376',
            'showCountryCodeList': false
        },
        'AE': {
            'status': 'assigned',
            'phoneCountryCode': '971',
            'showCountryCodeList': false
        },
        'AF': {
            'status': 'assigned',
            'phoneCountryCode': '93',
            'showCountryCodeList': false
        },
        'AG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AL': {
            'status': 'assigned',
            'phoneCountryCode': '355',
            'showCountryCodeList': false
        },
        'AM': {
            'status': 'assigned',
            'phoneCountryCode': '374',
            'showCountryCodeList': false
        },
        'AN': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'AO': {
            'status': 'assigned',
            'phoneCountryCode': '244',
            'showCountryCodeList': false
        },
        'AQ': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'AR': {
            'status': 'assigned',
            'phoneCountryCode': '54',
            'showCountryCodeList': false
        },
        'AS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'AT': {
            'status': 'assigned',
            'phoneCountryCode': '43',
            'showCountryCodeList': true
        },
        'AU': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': true
        },
        'AW': {
            'status': 'assigned',
            'phoneCountryCode': '297',
            'showCountryCodeList': false
        },
        'AZ': {
            'status': 'assigned',
            'phoneCountryCode': '994',
            'showCountryCodeList': false
        },
        'BA': {
            'status': 'assigned',
            'phoneCountryCode': '387',
            'showCountryCodeList': false
        },
        'BB': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BD': {
            'status': 'assigned',
            'phoneCountryCode': '880',
            'showCountryCodeList': false
        },
        'BE': {
            'status': 'assigned',
            'phoneCountryCode': '32',
            'showCountryCodeList': true
        },
        'BF': {
            'status': 'assigned',
            'phoneCountryCode': '226',
            'showCountryCodeList': false
        },
        'BG': {
            'status': 'assigned',
            'phoneCountryCode': '359',
            'showCountryCodeList': false
        },
        'BH': {
            'status': 'assigned',
            'phoneCountryCode': '973',
            'showCountryCodeList': false
        },
        'BI': {
            'status': 'assigned',
            'phoneCountryCode': '257',
            'showCountryCodeList': false
        },
        'BJ': {
            'status': 'assigned',
            'phoneCountryCode': '229',
            'showCountryCodeList': false
        },
        'BL': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'BM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BN': {
            'status': 'assigned',
            'phoneCountryCode': '673',
            'showCountryCodeList': false
        },
        'BO': {
            'status': 'assigned',
            'phoneCountryCode': '591',
            'showCountryCodeList': false
        },
        'BQ': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'BR': {
            'status': 'assigned',
            'phoneCountryCode': '55',
            'showCountryCodeList': false
        },
        'BS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'BT': {
            'status': 'assigned',
            'phoneCountryCode': '975',
            'showCountryCodeList': false
        },
        'BV': {
            'status': 'assigned'
        },
        'BW': {
            'status': 'assigned',
            'phoneCountryCode': '267',
            'showCountryCodeList': false
        },
        'BY': {
            'status': 'assigned',
            'phoneCountryCode': '375',
            'showCountryCodeList': false
        },
        'BZ': {
            'status': 'assigned',
            'phoneCountryCode': '501',
            'showCountryCodeList': false
        },
        'C2': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CA': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'CC': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CD': {
            'status': 'assigned',
            'phoneCountryCode': '243',
            'showCountryCodeList': false
        },
        'CF': {
            'status': 'assigned',
            'phoneCountryCode': '236',
            'showCountryCodeList': false
        },
        'CG': {
            'status': 'assigned',
            'phoneCountryCode': '242',
            'showCountryCodeList': false
        },
        'CH': {
            'status': 'assigned',
            'phoneCountryCode': '41',
            'showCountryCodeList': true
        },
        'CI': {
            'status': 'assigned',
            'phoneCountryCode': '225',
            'showCountryCodeList': false
        },
        'CK': {
            'status': 'assigned',
            'phoneCountryCode': '682',
            'showCountryCodeList': false
        },
        'CL': {
            'status': 'assigned',
            'phoneCountryCode': '56',
            'showCountryCodeList': false
        },
        'CM': {
            'status': 'assigned',
            'phoneCountryCode': '237',
            'showCountryCodeList': false
        },
        'CN': {
            'status': 'assigned',
            'phoneCountryCode': '86',
            'showCountryCodeList': false
        },
        'CO': {
            'status': 'assigned',
            'phoneCountryCode': '57',
            'showCountryCodeList': false
        },
        'CR': {
            'status': 'assigned',
            'phoneCountryCode': '506',
            'showCountryCodeList': false
        },
        'CU': {
            'status': 'assigned',
            'phoneCountryCode': '53',
            'showCountryCodeList': false
        },
        'CV': {
            'status': 'assigned',
            'phoneCountryCode': '238',
            'showCountryCodeList': false
        },
        'CW': {
            'status': 'assigned',
            'phoneCountryCode': '599',
            'showCountryCodeList': false
        },
        'CX': {
            'status': 'assigned',
            'phoneCountryCode': '61',
            'showCountryCodeList': false
        },
        'CY': {
            'status': 'assigned',
            'phoneCountryCode': '357',
            'showCountryCodeList': false
        },
        'CZ': {
            'status': 'assigned',
            'phoneCountryCode': '420',
            'showCountryCodeList': false
        },
        'DE': {
            'status': 'assigned',
            'phoneCountryCode': '49',
            'showCountryCodeList': false
        },
        'DJ': {
            'status': 'assigned',
            'phoneCountryCode': '253',
            'showCountryCodeList': false
        },
        'DK': {
            'status': 'assigned',
            'phoneCountryCode': '45',
            'showCountryCodeList': true
        },
        'DM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DO': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'DZ': {
            'status': 'assigned',
            'phoneCountryCode': '213',
            'showCountryCodeList': false
        },
        'EC': {
            'status': 'assigned',
            'phoneCountryCode': '593',
            'showCountryCodeList': false
        },
        'EE': {
            'status': 'assigned',
            'phoneCountryCode': '372',
            'showCountryCodeList': false
        },
        'EG': {
            'status': 'assigned',
            'phoneCountryCode': '20',
            'showCountryCodeList': false
        },
        'EH': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'ER': {
            'status': 'assigned',
            'phoneCountryCode': '291',
            'showCountryCodeList': false
        },
        'ES': {
            'status': 'assigned',
            'phoneCountryCode': '34',
            'showCountryCodeList': false
        },
        'ET': {
            'status': 'assigned',
            'phoneCountryCode': '251',
            'showCountryCodeList': false
        },
        'FI': {
            'status': 'assigned',
            'phoneCountryCode': '358',
            'showCountryCodeList': false
        },
        'FJ': {
            'status': 'assigned',
            'phoneCountryCode': '679',
            'showCountryCodeList': false
        },
        'FK': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'FM': {
            'status': 'assigned',
            'phoneCountryCode': '691',
            'showCountryCodeList': false
        },
        'FO': {
            'status': 'assigned',
            'phoneCountryCode': '298',
            'showCountryCodeList': false
        },
        'FR': {
            'status': 'assigned',
            'phoneCountryCode': '33',
            'showCountryCodeList': false
        },
        'GA': {
            'status': 'assigned',
            'phoneCountryCode': '241',
            'showCountryCodeList': false
        },
        'GB': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GD': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GE': {
            'status': 'assigned',
            'phoneCountryCode': '995',
            'showCountryCodeList': false
        },
        'GF': {
            'status': 'assigned',
            'phoneCountryCode': '594',
            'showCountryCodeList': false
        },
        'GG': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'GH': {
            'status': 'assigned',
            'phoneCountryCode': '233',
            'showCountryCodeList': false
        },
        'GI': {
            'status': 'assigned',
            'phoneCountryCode': '350',
            'showCountryCodeList': false
        },
        'GL': {
            'status': 'assigned',
            'phoneCountryCode': '299',
            'showCountryCodeList': false
        },
        'GM': {
            'status': 'assigned',
            'phoneCountryCode': '220',
            'showCountryCodeList': false
        },
        'GN': {
            'status': 'assigned',
            'phoneCountryCode': '224',
            'showCountryCodeList': false
        },
        'GP': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'GQ': {
            'status': 'assigned',
            'phoneCountryCode': '240',
            'showCountryCodeList': false
        },
        'GR': {
            'status': 'assigned',
            'phoneCountryCode': '30',
            'showCountryCodeList': false
        },
        'GS': {
            'status': 'assigned',
            'phoneCountryCode': '500',
            'showCountryCodeList': false
        },
        'GT': {
            'status': 'assigned',
            'phoneCountryCode': '502',
            'showCountryCodeList': false
        },
        'GU': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'GW': {
            'status': 'assigned',
            'phoneCountryCode': '245',
            'showCountryCodeList': false
        },
        'GY': {
            'status': 'assigned',
            'phoneCountryCode': '592',
            'showCountryCodeList': false
        },
        'HK': {
            'status': 'assigned',
            'phoneCountryCode': '852',
            'showCountryCodeList': true
        },
        'HM': {
            'status': 'assigned'
        },
        'HN': {
            'status': 'assigned',
            'phoneCountryCode': '504',
            'showCountryCodeList': false
        },
        'HR': {
            'status': 'assigned',
            'phoneCountryCode': '385',
            'showCountryCodeList': false
        },
        'HT': {
            'status': 'assigned',
            'phoneCountryCode': '509',
            'showCountryCodeList': false
        },
        'HU': {
            'status': 'assigned',
            'phoneCountryCode': '36',
            'showCountryCodeList': false
        },
        'ID': {
            'status': 'assigned',
            'phoneCountryCode': '62',
            'showCountryCodeList': false
        },
        'IE': {
            'status': 'assigned',
            'phoneCountryCode': '353',
            'showCountryCodeList': false
        },
        'IL': {
            'status': 'assigned',
            'phoneCountryCode': '972',
            'showCountryCodeList': false
        },
        'IM': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'IN': {
            'status': 'assigned',
            'phoneCountryCode': '91',
            'showCountryCodeList': false
        },
        'IO': {
            'status': 'assigned',
            'phoneCountryCode': '246',
            'showCountryCodeList': false
        },
        'IQ': {
            'status': 'assigned',
            'phoneCountryCode': '964',
            'showCountryCodeList': false
        },
        'IR': {
            'status': 'assigned',
            'phoneCountryCode': '98',
            'showCountryCodeList': false
        },
        'IS': {
            'status': 'assigned',
            'phoneCountryCode': '354',
            'showCountryCodeList': false
        },
        'IT': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'JE': {
            'status': 'assigned',
            'phoneCountryCode': '44',
            'showCountryCodeList': false
        },
        'JM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'JO': {
            'status': 'assigned',
            'phoneCountryCode': '962',
            'showCountryCodeList': false
        },
        'JP': {
            'status': 'assigned',
            'phoneCountryCode': '81',
            'showCountryCodeList': false
        },
        'KE': {
            'status': 'assigned',
            'phoneCountryCode': '254',
            'showCountryCodeList': false
        },
        'KG': {
            'status': 'assigned',
            'phoneCountryCode': '996',
            'showCountryCodeList': false
        },
        'KH': {
            'status': 'assigned',
            'phoneCountryCode': '855',
            'showCountryCodeList': false
        },
        'KI': {
            'status': 'assigned',
            'phoneCountryCode': '686',
            'showCountryCodeList': false
        },
        'KM': {
            'status': 'assigned',
            'phoneCountryCode': '269',
            'showCountryCodeList': false
        },
        'KN': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KP': {
            'status': 'assigned',
            'phoneCountryCode': '850',
            'showCountryCodeList': false
        },
        'KR': {
            'status': 'assigned',
            'phoneCountryCode': '82',
            'showCountryCodeList': false
        },
        'KW': {
            'status': 'assigned',
            'phoneCountryCode': '965',
            'showCountryCodeList': false
        },
        'KY': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'KZ': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'LA': {
            'status': 'assigned',
            'phoneCountryCode': '856',
            'showCountryCodeList': true
        },
        'LB': {
            'status': 'assigned',
            'phoneCountryCode': '961',
            'showCountryCodeList': false
        },
        'LC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'LI': {
            'status': 'assigned',
            'phoneCountryCode': '423',
            'showCountryCodeList': false
        },
        'LK': {
            'status': 'assigned',
            'phoneCountryCode': '94',
            'showCountryCodeList': false
        },
        'LR': {
            'status': 'assigned',
            'phoneCountryCode': '231',
            'showCountryCodeList': false
        },
        'LS': {
            'status': 'assigned',
            'phoneCountryCode': '266',
            'showCountryCodeList': false
        },
        'LT': {
            'status': 'assigned',
            'phoneCountryCode': '370',
            'showCountryCodeList': false
        },
        'LU': {
            'status': 'assigned',
            'phoneCountryCode': '352',
            'showCountryCodeList': false
        },
        'LV': {
            'status': 'assigned',
            'phoneCountryCode': '371',
            'showCountryCodeList': false
        },
        'LY': {
            'status': 'assigned',
            'phoneCountryCode': '218',
            'showCountryCodeList': false
        },
        'MA': {
            'status': 'assigned',
            'phoneCountryCode': '212',
            'showCountryCodeList': false
        },
        'MC': {
            'status': 'assigned',
            'phoneCountryCode': '377',
            'showCountryCodeList': false
        },
        'MD': {
            'status': 'assigned',
            'phoneCountryCode': '373',
            'showCountryCodeList': false
        },
        'ME': {
            'status': 'assigned',
            'phoneCountryCode': '382',
            'showCountryCodeList': false
        },
        'MF': {
            'status': 'assigned',
            'phoneCountryCode': '590',
            'showCountryCodeList': false
        },
        'MG': {
            'status': 'assigned',
            'phoneCountryCode': '261',
            'showCountryCodeList': false
        },
        'MH': {
            'status': 'assigned',
            'phoneCountryCode': '692',
            'showCountryCodeList': false
        },
        'MK': {
            'status': 'assigned',
            'phoneCountryCode': '389',
            'showCountryCodeList': false
        },
        'ML': {
            'status': 'assigned',
            'phoneCountryCode': '223',
            'showCountryCodeList': false
        },
        'MM': {
            'status': 'assigned',
            'phoneCountryCode': '95',
            'showCountryCodeList': false
        },
        'MN': {
            'status': 'assigned',
            'phoneCountryCode': '976',
            'showCountryCodeList': false
        },
        'MO': {
            'status': 'assigned',
            'phoneCountryCode': '853',
            'showCountryCodeList': false
        },
        'MP': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MQ': {
            'status': 'assigned',
            'phoneCountryCode': '596',
            'showCountryCodeList': false
        },
        'MR': {
            'status': 'assigned',
            'phoneCountryCode': '222',
            'showCountryCodeList': false
        },
        'MS': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'MT': {
            'status': 'assigned',
            'phoneCountryCode': '356',
            'showCountryCodeList': false
        },
        'MU': {
            'status': 'assigned',
            'phoneCountryCode': '230',
            'showCountryCodeList': false
        },
        'MV': {
            'status': 'assigned',
            'phoneCountryCode': '960',
            'showCountryCodeList': false
        },
        'MW': {
            'status': 'assigned',
            'phoneCountryCode': '265',
            'showCountryCodeList': false
        },
        'MX': {
            'status': 'assigned',
            'phoneCountryCode': '52',
            'showCountryCodeList': false
        },
        'MY': {
            'status': 'assigned',
            'phoneCountryCode': '60',
            'showCountryCodeList': false
        },
        'MZ': {
            'status': 'assigned',
            'phoneCountryCode': '258',
            'showCountryCodeList': false
        },
        'NA': {
            'status': 'assigned',
            'phoneCountryCode': '264',
            'showCountryCodeList': false
        },
        'NC': {
            'status': 'assigned',
            'phoneCountryCode': '687',
            'showCountryCodeList': false
        },
        'NE': {
            'status': 'assigned',
            'phoneCountryCode': '227',
            'showCountryCodeList': false
        },
        'NF': {
            'status': 'assigned',
            'phoneCountryCode': '672',
            'showCountryCodeList': false
        },
        'NG': {
            'status': 'assigned',
            'phoneCountryCode': '234',
            'showCountryCodeList': false
        },
        'NI': {
            'status': 'assigned',
            'phoneCountryCode': '505',
            'showCountryCodeList': false
        },
        'NL': {
            'status': 'assigned',
            'phoneCountryCode': '31',
            'showCountryCodeList': true
        },
        'NO': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': true
        },
        'NP': {
            'status': 'assigned',
            'phoneCountryCode': '977',
            'showCountryCodeList': false
        },
        'NR': {
            'status': 'assigned',
            'phoneCountryCode': '674',
            'showCountryCodeList': false
        },
        'NU': {
            'status': 'assigned',
            'phoneCountryCode': '683',
            'showCountryCodeList': false
        },
        'NZ': {
            'status': 'assigned',
            'phoneCountryCode': '64',
            'showCountryCodeList': false
        },
        'OM': {
            'status': 'assigned',
            'phoneCountryCode': '968',
            'showCountryCodeList': false
        },
        'PA': {
            'status': 'assigned',
            'phoneCountryCode': '507',
            'showCountryCodeList': false
        },
        'PE': {
            'status': 'assigned',
            'phoneCountryCode': '51',
            'showCountryCodeList': false
        },
        'PF': {
            'status': 'assigned',
            'phoneCountryCode': '689',
            'showCountryCodeList': false
        },
        'PG': {
            'status': 'assigned',
            'phoneCountryCode': '675',
            'showCountryCodeList': false
        },
        'PH': {
            'status': 'assigned',
            'phoneCountryCode': '63',
            'showCountryCodeList': false
        },
        'PK': {
            'status': 'assigned',
            'phoneCountryCode': '92',
            'showCountryCodeList': false
        },
        'PL': {
            'status': 'assigned',
            'phoneCountryCode': '48',
            'showCountryCodeList': true
        },
        'PM': {
            'status': 'assigned',
            'phoneCountryCode': '508',
            'showCountryCodeList': false
        },
        'PN': {
            'status': 'assigned',
            'phoneCountryCode': '870',
            'showCountryCodeList': false
        },
        'PR': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'PS': {
            'status': 'assigned',
            'phoneCountryCode': '970',
            'showCountryCodeList': false
        },
        'PT': {
            'status': 'assigned',
            'phoneCountryCode': '351',
            'showCountryCodeList': false
        },
        'PW': {
            'status': 'assigned',
            'phoneCountryCode': '680',
            'showCountryCodeList': false
        },
        'PY': {
            'status': 'assigned',
            'phoneCountryCode': '595',
            'showCountryCodeList': false
        },
        'QA': {
            'status': 'assigned',
            'phoneCountryCode': '974',
            'showCountryCodeList': false
        },
        'RE': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'RO': {
            'status': 'assigned',
            'phoneCountryCode': '40',
            'showCountryCodeList': false
        },
        'RS': {
            'status': 'assigned',
            'phoneCountryCode': '381',
            'showCountryCodeList': false
        },
        'RU': {
            'status': 'assigned',
            'phoneCountryCode': '7',
            'showCountryCodeList': false
        },
        'RW': {
            'status': 'assigned',
            'phoneCountryCode': '250',
            'showCountryCodeList': false
        },
        'SA': {
            'status': 'assigned',
            'phoneCountryCode': '966',
            'showCountryCodeList': false
        },
        'SB': {
            'status': 'assigned',
            'phoneCountryCode': '677',
            'showCountryCodeList': false
        },
        'SC': {
            'status': 'assigned',
            'phoneCountryCode': '248',
            'showCountryCodeList': false
        },
        'SD': {
            'status': 'assigned',
            'phoneCountryCode': '249',
            'showCountryCodeList': false
        },
        'SE': {
            'status': 'assigned',
            'phoneCountryCode': '46',
            'showCountryCodeList': true
        },
        'SG': {
            'status': 'assigned',
            'phoneCountryCode': '65',
            'showCountryCodeList': true
        },
        'SH': {
            'status': 'assigned',
            'phoneCountryCode': '290',
            'showCountryCodeList': false
        },
        'SI': {
            'status': 'assigned',
            'phoneCountryCode': '386',
            'showCountryCodeList': false
        },
        'SJ': {
            'status': 'assigned',
            'phoneCountryCode': '47',
            'showCountryCodeList': false
        },
        'SK': {
            'status': 'assigned',
            'phoneCountryCode': '421',
            'showCountryCodeList': false
        },
        'SL': {
            'status': 'assigned',
            'phoneCountryCode': '232',
            'showCountryCodeList': false
        },
        'SM': {
            'status': 'assigned',
            'phoneCountryCode': '378',
            'showCountryCodeList': false
        },
        'SN': {
            'status': 'assigned',
            'phoneCountryCode': '221',
            'showCountryCodeList': false
        },
        'SO': {
            'status': 'assigned',
            'phoneCountryCode': '252',
            'showCountryCodeList': false
        },
        'SR': {
            'status': 'assigned',
            'phoneCountryCode': '597',
            'showCountryCodeList': false
        },
        'SS': {
            'status': 'assigned',
            'phoneCountryCode': '211',
            'showCountryCodeList': false
        },
        'ST': {
            'status': 'assigned',
            'phoneCountryCode': '239',
            'showCountryCodeList': false
        },
        'SV': {
            'status': 'assigned',
            'phoneCountryCode': '503',
            'showCountryCodeList': false
        },
        'SX': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'SY': {
            'status': 'assigned',
            'phoneCountryCode': '963',
            'showCountryCodeList': false
        },
        'SZ': {
            'status': 'assigned',
            'phoneCountryCode': '268',
            'showCountryCodeList': false
        },
        'TC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TD': {
            'status': 'assigned',
            'phoneCountryCode': '235',
            'showCountryCodeList': false
        },
        'TF': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'TG': {
            'status': 'assigned',
            'phoneCountryCode': '228',
            'showCountryCodeList': false
        },
        'TH': {
            'status': 'assigned',
            'phoneCountryCode': '66',
            'showCountryCodeList': false
        },
        'TJ': {
            'status': 'assigned',
            'phoneCountryCode': '992',
            'showCountryCodeList': false
        },
        'TK': {
            'status': 'assigned',
            'phoneCountryCode': '690',
            'showCountryCodeList': false
        },
        'TL': {
            'status': 'assigned',
            'phoneCountryCode': '670',
            'showCountryCodeList': false
        },
        'TM': {
            'status': 'assigned',
            'phoneCountryCode': '993',
            'showCountryCodeList': false
        },
        'TN': {
            'status': 'assigned',
            'phoneCountryCode': '216',
            'showCountryCodeList': false
        },
        'TO': {
            'status': 'assigned',
            'phoneCountryCode': '676',
            'showCountryCodeList': false
        },
        'TR': {
            'status': 'assigned',
            'phoneCountryCode': '90',
            'showCountryCodeList': true
        },
        'TT': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'TV': {
            'status': 'assigned',
            'phoneCountryCode': '688',
            'showCountryCodeList': false
        },
        'TW': {
            'status': 'assigned',
            'phoneCountryCode': '886',
            'showCountryCodeList': true
        },
        'TZ': {
            'status': 'assigned',
            'phoneCountryCode': '255',
            'showCountryCodeList': false
        },
        'UA': {
            'status': 'assigned',
            'phoneCountryCode': '380',
            'showCountryCodeList': false
        },
        'UG': {
            'status': 'assigned',
            'phoneCountryCode': '256',
            'showCountryCodeList': false
        },
        'UM': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'US': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false,
            'hideInOtherCountries': true
        },
        'UY': {
            'status': 'assigned',
            'phoneCountryCode': '598',
            'showCountryCodeList': false
        },
        'UZ': {
            'status': 'assigned',
            'phoneCountryCode': '998',
            'showCountryCodeList': false
        },
        'VA': {
            'status': 'assigned',
            'phoneCountryCode': '39',
            'showCountryCodeList': false
        },
        'VC': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VE': {
            'status': 'assigned',
            'phoneCountryCode': '58',
            'showCountryCodeList': false
        },
        'VG': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VI': {
            'status': 'assigned',
            'phoneCountryCode': '1',
            'showCountryCodeList': false
        },
        'VN': {
            'status': 'assigned',
            'phoneCountryCode': '84',
            'showCountryCodeList': false
        },
        'VU': {
            'status': 'assigned',
            'phoneCountryCode': '678',
            'showCountryCodeList': false
        },
        'WF': {
            'status': 'assigned',
            'phoneCountryCode': '681',
            'showCountryCodeList': false
        },
        'WS': {
            'status': 'assigned',
            'phoneCountryCode': '685',
            'showCountryCodeList': false
        },
        'YE': {
            'status': 'assigned',
            'phoneCountryCode': '967',
            'showCountryCodeList': false
        },
        'YT': {
            'status': 'assigned',
            'phoneCountryCode': '262',
            'showCountryCodeList': false
        },
        'ZA': {
            'status': 'assigned',
            'phoneCountryCode': '27',
            'showCountryCodeList': false
        },
        'ZM': {
            'status': 'assigned',
            'phoneCountryCode': '260',
            'showCountryCodeList': false
        },
        'ZW': {
            'status': 'assigned',
            'phoneCountryCode': '263',
            'showCountryCodeList': false
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/phone/lib/territoriesByCode.js
// module id = ./components/xo-form-components/src/phone/lib/territoriesByCode.js
// module chunks = 1